// extracted by mini-css-extract-plugin
export var table = "_vf-0";